module.exports = __webpack_public_path__ + "img/Banner.5d709fab.jpg";